<template>
	<DefaultSection>
		<div
			:class="[
				hasBackground ? backgroundColor : backgroundTransparent,
				hasPadding ? containedClass : customClass,
			]"
		>
			<slot />
		</div>
	</DefaultSection>
</template>

<script setup>
import DefaultSection from '@/components/sections/DefaultSection.vue'

const props = defineProps({
	hasBackground: {
		type: Boolean,
		default: false,
		required: false,
	},
	backgroundColor: {
		type: String,
		default: 'bg-gray-100',
		required: false,
	},
	backgroundTransparent: {
		type: String,
		default: 'bg-transparent',
		required: false,
	},
	containedClass: {
		type: String,
		default: 'contained-section',
		required: false,
	},
	isTransparent: {
		type: Boolean,
		default: false,
		required: false,
	},
	hasPadding: {
		type: Boolean,
		default: true,
		required: false,
	},
	customClass: {
		type: String,
		default: '',
		required: false,
	},
})
</script>
